export default {
  GET_INVITE_LANDING_PAGE_INFO: '/invite/get_invite_landing_page', // 获取落地页面信息
};
